import $api from "../http";
import {
  IAttachPaymentMethod,
  IBuyAddonModel,
  IBuySubscriptionModel,
  ICancelSubscriptionModel,
  IChangeSubscriptionModel,
  IPaymentMethod,
  IStripePaymentResponse,
} from "../models/Stripe";

class StripeServiceClass {
  async getPublicKey() {
    return await $api.get<{ publicKey: string }>("api/stripe/settings/public-key");
  }

  async getPaymentMethods() {
    return await $api.get<{ paymentMethods: IPaymentMethod[] }>("api/stripe/payment-method/all");
  }

  async attachPaymentMethod(model: IAttachPaymentMethod) {
    return await $api.post<{}>("api/stripe/payment-method/attach", model);
  }

  async setAsDefaultPaymentMethod(paymentMethodId: string) {
    return await $api.put<{}>(`api/stripe/payment-method/set-as-default/${paymentMethodId}`);
  }

  async detachPaymentMethod(paymentMethodId: string) {
    return await $api.delete<{}>(`api/stripe/payment-method/detach/${paymentMethodId}`);
  }

  async buyAddon(model: IBuyAddonModel) {
    return await $api.post<IStripePaymentResponse>(`api/stripe/addon/buy`, model);
  }

  async changeSubscription(model: IChangeSubscriptionModel) {
    return await $api.put<IStripePaymentResponse>(
      `api/stripe/subscription/change/${model.subscriptionId}`,
      {}
    );
  }

  async buySubscription(model: IBuySubscriptionModel) {
    return await $api.post<IStripePaymentResponse>(`api/stripe/subscription/buy`, model);
  }

  async cancelSubscription(id: string, model: ICancelSubscriptionModel) {
    return await $api.delete<{}>(`api/stripe/subscription/cancel/${id}`, { data: model });
  }

  async resumeSubscriptionCancellation(userSubscriptionId: string) {
    return await $api.put<{}>(
      `api/stripe/subscription/resume-cancellation/${userSubscriptionId}`,
      {}
    );
  }
}

export const StripeService = new StripeServiceClass();
